import { render } from "./FinancialFitnessScore.vue?vue&type=template&id=82bbe3a8&scoped=true"
import script from "./FinancialFitnessScore.vue?vue&type=script&lang=js"
export * from "./FinancialFitnessScore.vue?vue&type=script&lang=js"

import "./FinancialFitnessScore.vue?vue&type=style&index=0&id=82bbe3a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bbe3a8"]])

export default __exports__